import React from "react";
import { motion } from "framer-motion";

const HomeContact = ({ contact }) => (
  <section
    id="contact"
    className="py-5 text-center text-light position-relative"
    style={{
      backgroundImage: `url(${contact.background})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      overflow: "hidden",
    }}
  >
    <div
      className="position-absolute w-100 h-100"
      style={{
        top: 0,
        left: 0,
        background: contact.use_bg_color == 1
          ? `linear-gradient(135deg, ${contact.bg_color1}CC, ${contact.bg_color2}CC)`
          : "transparent",
        zIndex: 1,
      }}
    ></div>

    <div className="container position-relative z-2">
      <motion.h2
        className="fw-bold mb-3"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        {contact.title}
      </motion.h2>
      <p className="mb-4">{contact.subtitle}</p>
      <motion.button
        className="btn btn-lg"
        style={{
          backgroundColor: "#F17E00",
          color: "#fff",
          borderRadius: "25px",
          padding: "10px 30px",
          fontWeight: "600",
        }}
        whileHover={{ scale: 1.05 }}
        onClick={() => (window.location.href = "/contact-us")}
      >
        {contact.btnText}
      </motion.button>
    </div>
  </section>
);

export default HomeContact;
